import Orders from "./orders-list/Orders";
import { Util } from "../shared/services";
import {HCROUTES} from "../shared/constants/Constant";

const orderRoutes = [
    {
        path: '/danh-sach-ve',
        name: HCROUTES.order,
        component: Orders,
        meta: {
            title: 'Danh sách vé'
        },
        beforeEnter: Util.authenticatedRoute
    }
];

export default orderRoutes;
